module.exports = __webpack_public_path__ + "img/noData.547c7393.png";